module.exports = __webpack_public_path__ + "img/review-grid-02.aaecdff3.png";